import { AlphaBIcon } from './AlphaBIcon';

/**
 * author: GreenTurtwig
 * id 910DF87E-809E-40D6-886F-34E581899455
 * name alpha-b
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-b.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetBIcon = AlphaBIcon;
export default AlphabetBIcon